<script setup lang="ts">

import {watch} from "vue";

const model = defineModel<boolean | null>()

defineProps<{
    id: string,
    label?: string,
    disabled?: boolean,
    required?: boolean,
    error?: string,
    options: { value: boolean, label: string }[],
}>()

const emit = defineEmits(['clearError'])

watch(model, () => emit('clearError'))

</script>

<template>
    <div class="space-y-4">
        <label class="text-sm">
            {{ label }}<span v-if="required" class="text-primary ml-2">*</span>
        </label>

        <div class="flex flex-col md:flex-row gap-2 md:gap-8">
            <label v-for="option in options" :key="String(option.value)" class="flex items-center gap-4 w-fit cursor-pointer">
                <input
                    type="radio"
                    :name="id"
                    :value="option.value"
                    :disabled="disabled"
                    v-model="model"
                    class="sr-only"
                />

                <span class="flex items-center grow text-xs">
                    <span class="flex items-center h-15 relative pr-2">
                        <img v-if="model === option.value" class="w-4 !m-0 !p-0" src="../../public/icons/checked-circle.svg" alt="">
                        <img v-else class="w-4 !m-0 !p-0" src="../../public/icons/unchecked-circle.svg" alt="">
                    </span>
                    {{ option.label }}
                </span>
            </label>
        </div>

        <div v-if="error" class="text-xs text-primary mt-2">{{ error }}</div>
    </div>
</template>
